/* eslint-disable no-unused-vars */
import React from "react";

function ClubContainer({menu}) {
  return null
}

export default ClubContainer;